import { fieldStyles } from '../field-styles'
import { cn } from '@/core/utils/common'

export const choiceStyles = {
  trigger: cn(
    fieldStyles.control,
    fieldStyles.outline,
    'group flex cursor-pointer items-center gap-3 text-left data-[popup-open]:border-point aria-invalid:data-[popup-open]:border-error'
  ),
  /** ghost — 테두리 · 바탕 없이 글자 + 셰브론. 포커스는 글자색 변화(LLM-Guide §0 non-ring focus) */
  ghostTrigger:
    'group inline-flex h-10 min-w-0 cursor-pointer items-center gap-1 text-c14 font-medium text-description outline-none transition-colors duration-150 hover:text-foreground focus-visible:text-foreground data-[popup-open]:text-foreground disabled:cursor-not-allowed disabled:opacity-60',
  /** bare — 동작에 필요한 배치만. 외형은 호출부가 준다 */
  bareTrigger: 'group flex cursor-pointer items-center gap-3 text-left',
  /** ghost 팝업은 트리거(글자) 폭이 아니라 내용 폭 */
  ghostPopup: 'w-max! min-w-40',
  positioner: 'z-[5000200] max-w-[calc(100vw-2rem)] outline-none',
  popup:
    'flex w-[var(--anchor-width)] max-w-[var(--available-width)] max-h-[var(--available-height)] flex-col overflow-hidden rounded-panel glass-menu outline-none origin-[var(--transform-origin)] transition-[opacity,scale] duration-150 data-[starting-style]:scale-[0.98] data-[starting-style]:opacity-0 data-[ending-style]:scale-[0.98] data-[ending-style]:opacity-0',
  list: 'min-h-0 max-h-72 overflow-y-auto overscroll-contain p-1.5 outline-none',
  item: 'flex min-h-11 w-full cursor-pointer items-center gap-3 rounded-control px-3 py-2.5 text-c14 leading-5 text-foreground select-none outline-none transition-colors data-[highlighted]:bg-surface-strong data-[selected]:font-medium data-[selected]:text-point data-[disabled]:cursor-not-allowed data-[disabled]:text-description data-[disabled]:opacity-50',
} as const
